import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ fontWeights, palette }: Theme) => ({
  label: {
    marginTop: '1.5rem',
    paddingTop: '1.5rem',
    borderTop: `1px solid ${palette.grey[400]}`,
    '& span': {
      fontWeight: fontWeights.medium,
    },
  },
  mms: {
    marginBottom: 0,
  },
}));
